import React, { Component, createRef } from 'react';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import TextInput from 'Components/Forms/Elements/TextInput';
import Modal from 'Modals/ModalComponent/Modal';
import Loader from 'Pure/Loader';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
const {
  qwest
} = window;
export default class BookingCommentModal extends Component {
  state = {
    status_messages: {}
  };
  ref = createRef();
  handleChange = handleChange.bind(this);
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.open !== prev_props.open) {
      component.setState({
        info: undefined,
        warning: undefined,
        error: undefined
      });
    }
    if (prev_props.booking?.id !== props.booking?.id) {
      component.setState({
        comment: props.booking?.comment || ''
      });
    }
  }
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('SetBookingComment'), {
      booking_id: props.booking?.id,
      comment: state.comment
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info
      });
      props.booking.comment = state.comment;
      window.setTimeout(() => component.ref?.current?.click?.(), 1000);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let title = 'Commentaire';
    if (props.booking?.number !== undefined) {
      title += ' - réservation n°' + props.booking.number;
    }
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const output = /*#__PURE__*/React.createElement(Modal, {
      open: props.open === true,
      onClose: props.onClose,
      title: title,
      "scroll-area": ".back-page, .front-page",
      bemit: ['default', 'medium', 'simple'],
      "close-label": "Fermer",
      "hide-controls": false,
      src: props.trigger_src,
      "with-footer-close": true,
      "close-ref": component.ref,
      "close-classes": "c-flat-btn"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "u-margin-bottom-20",
      value: state['comment'],
      name: "comment",
      label: "Commentaire",
      rows: "4",
      multiline: true,
      status: state.status_messages
    }), getFormStatus(state), /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, "Enregistrer", loader));
    return output;
  }
}
